"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccepterBlock = void 0;
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var c = (0, BemBuilder_1.default)("accepter-block");
var AccepterBlock = (function (_super) {
    __extends(AccepterBlock, _super);
    function AccepterBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formatDate = function () {
            var date = _this.props.date;
            return new Date(date).toLocaleDateString();
        };
        return _this;
    }
    AccepterBlock.prototype.render = function () {
        var _a;
        var _b = this.props, name = _b.name, esignature = _b.esignature, esignatureMethod = _b.esignatureMethod;
        var hasEsignature = !!esignature;
        return (react_1.default.createElement(kaleidoscope_1.Card, { className: c() },
            react_1.default.createElement("div", { className: (0, classnames_1.default)(c("signature")), style: { backgroundImage: hasEsignature ? "url(\"data:image/png;base64,".concat(esignature, "\")") : "" } },
                react_1.default.createElement("div", { className: (0, classnames_1.default)((_a = {},
                        _a["".concat(c("details"))] = true,
                        _a["".concat(c("details", "with-signature"))] = hasEsignature,
                        _a["".concat(c("details", "with-signature-".concat(esignatureMethod)))] = hasEsignature && !!esignatureMethod,
                        _a)) },
                    react_1.default.createElement("div", { className: c("name") }, name),
                    react_1.default.createElement("div", { className: c("datestamp") }, this.formatDate())))));
    };
    return AccepterBlock;
}(react_1.default.Component));
exports.AccepterBlock = AccepterBlock;
